import { render, staticRenderFns } from "./FinancialRewards.vue?vue&type=template&id=708890cb&scoped=true&"
import script from "./FinancialRewards.vue?vue&type=script&lang=js&"
export * from "./FinancialRewards.vue?vue&type=script&lang=js&"
import style0 from "./FinancialRewards.vue?vue&type=style&index=0&id=708890cb&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708890cb",
  null
  
)

export default component.exports